import React, { FC, useState, useEffect } from 'react';
import { makeStyles, Container } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  navSpace: {
    marginTop: 32,
  },
}));

const StateDependOnEachOther: FC = () => {
  const classes = useStyles();
  const [canSubmit, setCanSubmit] = useState(true);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    canSubmit2: true,
    loading2: false,
  });

  const submitting = () => {
    setCanSubmit(() => {
      if (loading) {
        return false;
      }

      return true;
    });
  };

  const submitting2 = () => {
    setState(prevCanSubmit2 => {
      if (prevCanSubmit2.loading2) {
        return {
          ...prevCanSubmit2,
          canSubmit2: false,
        };
      }

      return {
        ...prevCanSubmit2,
        canSubmit2: true,
      };
    });
  };

  useEffect(() => {
    setLoading(true);
    setState(prevState => {
      return { ...prevState, loading2: true };
    });
    submitting();
    submitting2();
    // eslint-disable-next-line
  }, []);

  return (
    <Container maxWidth="md" className={classes.navSpace}>
      <div>別々の useState で定義: canSubmit: {`${canSubmit}`}</div>
      <div>同じ useState で定義 state.canSubmit2: {`${state.canSubmit2}`}</div>
    </Container>
  );
};

export default StateDependOnEachOther;
